import { render } from "./HumanizeTime.vue?vue&type=template&id=5bf5b3c2"
import script from "./HumanizeTime.vue?vue&type=script&lang=js"
export * from "./HumanizeTime.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
